module["exports"] = [
  "#{Address.city_name}"
];
